<template>
  <div class="container">
      <el-row  type="flex" justify="center"> 
        <el-col :span="24">
          <router-view></router-view>
        </el-col>
      </el-row>

  </div>
</template>
<script type="text/javascript">
export default {
  name: 'qrGenerate',
  components: {
  }
}
</script>

<style type="text/css" scoped>
</style>
